import './style.scss';
import {Home} from './components/Home';
import {Success} from './components/Success';
import Router from "preact-router";

export default function App() {
	return (
		<Router>
			<Home path='/'/>
			<Success path='/success'/>
		</Router>
	);
}
